import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {

	return {
		wrapper: {
		},
		inputWrapper: {
			width                  : "80%",
			"& .MuiFormLabel-root" : {
				display: "none"
			}
		},
		customInputField: {
			fontSize        : "1.6rem",
			fontWeight      : 500,
			textAlign       : "left",
			borderWidth     : "0",
			padding         : "2rem",
			paddingLeft     : "4.5rem !important",
			backgroundColor : theme.other.colors.input.primary
		},
		svgIcon: {
			...theme.other.svgIcons.size20,
			marginLeft: "1rem"
		},
		inputUnderline: {
			"&&&:before": {
				borderBottom: "none"
			},
			"&&:after": {
				borderBottom: "none"
			}
		},
		errorIcon: {
			...theme.other.svgIcons.size20
		},
		tooltipRoot: {
			zIndex: "1200"
		},
		tooltipWrapper: {
			background : "#fff",
			boxShadow  : "0 0 5px 0 rgba(0, 0, 0, 0.16)",
			color      : "#000",
			zIndex     : "1200"
		},
		cssFocused: {
			borderColor: "#126bd5 !important"
		},
		notchedOutlineErrorBorder: {
			borderWidth : "1px",
			borderColor : `${ theme.other.paletteNew.tertiaryErrorRed } !important`
		},
		notchedOutline: {
			borderWidth : "1px",
			borderColor : "#e7e7e700 !important"
		},
		root: {
			borderRadius : "1rem",
			outline      : !props?.errorMsg ? "none" : `1px solid ${ theme.other.paletteNew.tertiaryErrorRed }`,
			caretColor   : theme.other.paletteNew.primaryDarkBlue,
			marginBottom : "0.5rem",

			"& input": {
				color: theme.other.colors.text.primary,

				"&::placeholder": {
					color: theme.other.colors.text.primary
				}
			},

			"& .MuiOutlinedInput-root": {
				paddingLeft     : "0.5rem",
				paddingRight    : "0",
				borderRadius    : "1rem",
				backgroundColor : theme.other.paletteNew.darkModeDarkGrey20,

				"&.Mui-focused fieldset": {
					borderColor: `${ theme.other.paletteNew.primaryDarkBlue } !important`
				},

				"& fieldset": {
					borderWidth: "0px"

				}
			}

		},
		errorMsg: {
			fontSize     : "1.4rem",
			color        : theme.other.paletteNew.tertiaryErrorRed,
			marginBottom : "1.25rem"
		},
		normalMsg: {
			fontSize     : "1.4rem",
			marginBottom : "1.25rem"

		}
	};
} );

